import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { SocialProof } from './components/SocialProof';
import { WhoItsFor } from './components/WhoItsFor';
import { PainPoints } from './components/PainPoints';
import { ProductBreakdown } from './components/ProductBreakdown';
import { WhyChoose } from './components/WhyChoose';
import { Countdown } from './components/Countdown';
import { WhatsAppTestimonials } from './components/WhatsAppTestimonials';
import { Pricing } from './components/Pricing';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  useEffect(() => {
    const imgLink = document.createElement('link');
    imgLink.rel = 'preload';
    imgLink.as = 'image';
    imgLink.href = 'https://cdn.magicpatterns.com/uploads/tmoM3QPgSs3tumHqJ5iocx/hf_20260516_163314_aa7428a1-182f-493a-9299-dd713a79f6f8.png';
    document.head.appendChild(imgLink);
  }, []);
  return <main className="w-full min-h-screen bg-sky-100 selection:bg-blue-200 selection:text-blue-900" data-id="element-0" data-mp="3ii4ro0w5cqo1">
      <MetaPixel data-id="element-1" data-mp="3mj6j3vjtnyfg" />
      <Hero data-id="element-2" data-mp="3rcj8i7wbs999" />
      <SocialProof data-id="element-3" data-mp="3rbzmog3k10py" />
      <WhoItsFor data-id="element-4" data-mp="3rdkie91luppe" />
      <PainPoints data-id="element-5" data-mp="3rd1a7k1rbfok" />
      <ProductBreakdown data-id="element-6" data-mp="3relvej26lm9r" />
      <WhyChoose data-id="element-7" data-mp="6hqffdy0fe4" />
      <Countdown data-id="element-8" data-mp="4wvhonpuufq" />
      <WhatsAppTestimonials data-id="element-9" data-mp="5gel8p3rovc" />
      <Pricing data-id="element-10" data-mp="7suzhf7pr6a" />
      <FAQ data-id="element-11" data-mp="2zld1d7i6tbah" />
      <FinalCTA data-id="element-12" data-mp="2zlldgx6hkckm" />
      <Footer data-id="element-13" data-mp="2zm4zaoz9bl3x" />
    </main>;
}